import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.css';

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="about-hero">
        <div className="container">
          <h1 className="about-hero-title">
            <i className="fas fa-university me-3"></i>
            About FUWJALS
          </h1>
          <p className="about-hero-subtitle">
            Federal University Wukari Journal of Agriculture and Life Sciences
          </p>
        </div>
      </div>

      <div className="container py-5">
        <div className="row">
          <div className="col-lg-10 mx-auto">
          
          {/* Journal Overview */}
          <div className="about-card" style={{ animationDelay: '0.1s' }}>
            <div className="about-card-header">
              <h2 className="about-card-title">
                <i className="fas fa-book-open"></i>
                Journal Overview
              </h2>
            </div>
              <p className="card-text">
                The Federal University Wukari Journal of Agriculture and Life Sciences (FUWJALS) is a peer-reviewed 
                academic journal published by the Faculty of Agriculture and Life Sciences, Federal University Wukari, 
                Nigeria. FUWJALS publishes original research articles, review papers, and short communications in all 
                aspects of agriculture and life sciences.
              </p>
              <p className="card-text">
                Founded in 2015, FUWJALS aims to disseminate high-quality research findings that contribute to the 
                advancement of knowledge in agriculture and related disciplines. The journal provides a platform for 
                academics, researchers, and practitioners to share their work and engage in scholarly discourse.
              </p>
          </div>

          {/* Scope and Focus */}
          <div className="about-card" style={{ animationDelay: '0.2s' }}>
            <div className="about-card-header">
              <h2 className="about-card-title">
                <i className="fas fa-bullseye"></i>
                Scope and Focus
              </h2>
            </div>
              <p className="card-text">
                FUWJALS publishes research in the following areas:
              </p>
              <ul>
                <li>Agricultural Economics and Extension</li>
                <li>Animal Science and Production</li>
                <li>Crop Science and Production</li>
                <li>Soil Science and Land Management</li>
                <li>Agricultural Engineering and Mechanization</li>
                <li>Food Science and Technology</li>
                <li>Forestry and Wildlife Management</li>
                <li>Fisheries and Aquaculture</li>
                <li>Environmental Sciences</li>
                <li>Plant and Animal Biotechnology</li>
                <li>Agricultural Biodiversity and Conservation</li>
                <li>Climate Change and Agriculture</li>
              </ul>
              <p className="card-text">
                We particularly welcome research that addresses challenges facing agriculture in developing countries 
                and contributes to sustainable development.
              </p>
          </div>

          {/* Publication Frequency */}
          <div className="about-card" style={{ animationDelay: '0.3s' }}>
            <div className="about-card-header">
              <h2 className="about-card-title">
                <i className="fas fa-calendar-alt"></i>
                Publication Frequency
              </h2>
            </div>
              <p className="card-text">
                FUWJALS is published quarterly (March, June, September, and December). Special issues may be published 
                on topical themes as determined by the Editorial Board.
              </p>
          </div>

          {/* Peer Review Process */}
          <div className="about-card" style={{ animationDelay: '0.4s' }}>
            <div className="about-card-header">
              <h2 className="about-card-title">
                <i className="fas fa-user-check"></i>
                Peer Review Process
              </h2>
            </div>
              <p className="card-text">
                All manuscripts submitted to FUWJALS undergo a thorough double-blind peer review process. Initial 
                screening is done by the Editor-in-Chief to assess suitability for the journal. Suitable manuscripts 
                are then assigned to relevant Section Editors who oversee the peer review process.
              </p>
              <p className="card-text">
                Each manuscript is reviewed by at least two independent experts in the field who evaluate the scientific 
                merit, originality, methodology, and relevance of the research. Authors are provided with detailed feedback 
                and recommendations for improvement.
              </p>
              <p className="card-text">
                The final decision to accept, revise, or reject a manuscript rests with the Editor-in-Chief, guided by 
                the recommendations of the Section Editors and reviewers.
              </p>
          </div>

          {/* Ethics and Policies */}
          <div className="about-card" style={{ animationDelay: '0.5s' }}>
            <div className="about-card-header">
              <h2 className="about-card-title">
                <i className="fas fa-balance-scale"></i>
                Ethics and Policies
              </h2>
            </div>
              <p className="card-text">
                FUWJALS adheres to the highest standards of publication ethics and expects the same from authors, reviewers, 
                and editors. The journal follows the guidelines of the Committee on Publication Ethics (COPE).
              </p>
              <p className="card-text">
                Key policies include:
              </p>
              <ul>
                <li>Originality and plagiarism: All submitted manuscripts must be original and not under consideration 
                    elsewhere. Plagiarism in any form is unacceptable.</li>
                <li>Authorship: All listed authors must have made significant contributions to the research and approve 
                    the final version of the manuscript.</li>
                <li>Conflict of interest: Authors, reviewers, and editors must disclose any potential conflicts of interest.</li>
                <li>Research ethics: Research involving humans or animals must adhere to relevant ethical guidelines and 
                    obtain appropriate approvals.</li>
                <li>Data sharing: Authors are encouraged to make their data available where possible.</li>
              </ul>
          </div>

          {/* Open Access Policy */}
          <div className="about-card" style={{ animationDelay: '0.6s' }}>
            <div className="about-card-header">
              <h2 className="about-card-title">
                <i className="fas fa-unlock-alt"></i>
                Open Access Policy
              </h2>
            </div>
              <p className="card-text">
                FUWJALS is an open access journal. All published articles are freely available online to readers worldwide, 
                maximizing the visibility and impact of research. Authors retain copyright of their work but grant the journal 
                the right to publish and distribute their articles.
              </p>
              <p className="card-text">
                A modest publication fee may be charged to cover the costs of peer review, production, and online hosting. 
                Fee waivers may be available for authors from low-income countries or those facing financial hardship.
              </p>
          </div>

          {/* Contact Information */}
          <div className="about-card" style={{ animationDelay: '0.7s' }}>
            <div className="about-card-header">
              <h2 className="about-card-title">
                <i className="fas fa-envelope"></i>
                Contact Information
              </h2>
            </div>
              <p className="card-text">
                For inquiries about manuscript submissions, the review process, or other matters related to the journal, 
                please contact:
              </p>
              <p className="card-text">
                <strong>Editor-in-Chief</strong><br />
                Federal University Wukari Journal of Agriculture and Life Sciences<br />
                Faculty of Agriculture and Life Sciences<br />
                Federal University Wukari<br />
                PMB 1020, Wukari<br />
                Taraba State, Nigeria<br />
                Email: journal@fuwukari.edu.ng
              </p>
          </div>

          {/* Call to Action */}
          <div className="about-cta">
            <h2 className="cta-title">Ready to Contribute?</h2>
            <p className="cta-subtitle">
              Join our community of researchers and scholars making an impact in agriculture and life sciences
            </p>
            <div className="cta-buttons">
              <Link to="/submit-paper" className="cta-btn cta-btn-primary">
                <i className="fas fa-paper-plane me-2"></i>
                Submit Your Paper
              </Link>
              <Link to="/editorial-board" className="cta-btn cta-btn-secondary">
                <i className="fas fa-users me-2"></i>
                View Editorial Board
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default About;
